export default "__VITE_ASSET__BCGj79On__"